// frontend/src/services/reportService.js
import api from './api';

export const getZoneProgressReport       = () => api.get('/reports/zone-progress');
export const getCommandProgressReport    = () => api.get('/reports/command-progress');
export const getDailyProgressReport      = (startDate, endDate) =>
  api.get('/reports/daily-progress', { params: { startDate, endDate } });
export const getSalaryComplaintsReport   = () => api.get('/reports/salary-complaints');
export const getNonVerificationReport    = () => api.get('/reports/non-verification');
export const getOfficerPerformanceReport = () => api.get('/reports/officer-performance');
export const getTransferRequestsReport   = () => api.get('/reports/transfer-requests');
export const getPreClearanceReport       = () => api.get('/reports/pre-clearance');
export const getPersonnelVerificationStatusReport = () => api.get('/reports/personnel-verification-status');